import { Injectable } from '@angular/core';
import { Effect, Actions } from '@ngrx/effects';

// Rxjs
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/exhaustMap';
import 'rxjs/add/operator/takeWhile';

import { of } from 'rxjs/observable/of';
import { Observable } from 'rxjs/Observable';

// Services
import { NotificationService } from '../services/notification.service';

// Actions
import * as UIActions from '../actions/ui.actions';
import * as NotificationActions from '../actions/notification.actions';

@Injectable()
export class NotificationEffects {

  // Constructor
  constructor(
    private actions$: Actions,
    private notifications: NotificationService
  ) {}

  // ======= CHECK USER NOTIFICATIONS ========
  // ====================================================
  @Effect()
  checkNotifications$ = this.actions$
    .ofType(NotificationActions.CHECK_USER_NOTIFICATIONS)
    .map((action: NotificationActions.CheckUserNotifications) => [])
    .exhaustMap( () => {
        return Observable.interval(30000)
            .takeWhile(() => typeof sessionStorage.getItem('csi-session-token') === 'string')
            .map(() => new NotificationActions.GetUserNotifications());
    }
  );

  @Effect()
  getUserNotifications$ = this.actions$
    .ofType(NotificationActions.GET_USER_NOTIFICATIONS)
    .map((action: NotificationActions.GetUserNotifications) => [])
    .exhaustMap(() => {
       return this.notifications.getUserNotification()
        .map((response: any) => new NotificationActions.GetUserNotificationsSuccess(response.data))
        .catch(() => of());
    }
  );

}



// WEBPACK FOOTER //
// ./src/app/core/effects/notification.effects.ts